export const PRO_MODE_TRANSITION_DURATIONS = Object.freeze({
  cut: 0,
  fade: 560,
  dissolve: 680,
  blend: 760,
});

export const getProModeTransitionDuration = (transitionType) => (
  PRO_MODE_TRANSITION_DURATIONS[transitionType]
  ?? PRO_MODE_TRANSITION_DURATIONS.cut
);
